import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'summary-product-item',
  props: {
    name: { default: '' },
    price: { default: '' },
    isDiscount: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})